export const COLUMN = 'column';
export const ROW = 'row';

export const ORIENTATION_MARGIN = {
  [ROW]: 'marginLeft',
  [COLUMN]: 'marginTop'
};
